import React from "react";
import * as styles from "./popup-sheet-list-entry.module.scss";
import SelectableCard from "../selectable-card";
import { classArr } from "../../helper/style-helper";

export interface PopupSheetListEntryProps {
	style?: React.CSSProperties;
	className?: string;
	selected?: boolean;
	onClick?: VoidFunction;
	children?: React.ReactNode;
}

/**
 * A selectable card with extra styling suitable for a popup sheet list
 */
export default function PopupSheetListEntry(props: PopupSheetListEntryProps) {
	return (
		<SelectableCard
			style={props.style}
			className={classArr(styles.container, props.className)}
			selected={props.selected}
			onClick={props.onClick}
		>
			{props.children}
		</SelectableCard>
	);
}
